module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/mapaDopravnichProudu-a272a01364f348c8dc840c07224e3cac.svg";